// src/utils/globalVariables.js

export const getJwt = () => {
  return localStorage.getItem('jwt') || '';
};

export const setJwt = (jwt: string) => {
  localStorage.setItem('jwt', jwt);
};

export const clearJwt = () => {
  localStorage.removeItem('jwt');
};
